import { api } from '../common/api'

export const anoVerify = (params: Pick<AllParams, 'ano'>) => api.post<null>('/customer/registion/ano/verify', params, { hideMsg: true, })

export const registerSendSMS = (params: Pick<AllParams, 'ano'>) => api.get<Pick<AllResponse, 'regId' | 'tel' | 'email'>>('/customer/registion/sms', { params, hideMsg: true })

export const registerSMSVerify = (params: Pick<AllParams, 'sms' | 'regId'>) => api.post<null>('/customer/registion/sms/verify', params, { hideMsg: true })

export const registerSubmit = (params: Pick<AllParams, 'usrId' | 'image' | 'pwd' | 'regId' | 'scrt' | 'email'>) => api.post<{code: number, data: any, message: string}>('/customer/registion/register', params,  { hideMsg: true, usePayload: true })

export const registerUsernameVerify = (username: string) => api.post('/customer/registion/un/verify', { username }, { hideMsg: true })